// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 控制面板样式 */

.control-panel {
  padding: 2rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  position: relative;
  overflow-y: auto;
  overflow-x: hidden;
}


.panel-header {
  text-align: center;
  border-bottom: 1px solid var(--gray-200);
  padding-bottom: 1.5rem;
}

.panel-header h2 {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--gray-800);
  margin-bottom: 0.5rem;
}

.panel-header h2 i {
  color: var(--mango-500);
}

.panel-header p {
  color: var(--gray-600);
  font-size: 0.875rem;
}

.panel-content {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.share-controls {
  background: rgba(255, 255, 255, 0.5);
  border-radius: 12px;
  padding: 1.5rem;
  border: 1px solid var(--gray-200);
}

.share-controls h3 {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1rem;
  font-weight: 600;
  color: var(--gray-800);
  margin-bottom: 1rem;
}

.share-controls h3 i {
  color: var(--leaf-500);
}

.control-buttons {
  margin-bottom: 1rem;
}

.sharing-status {
  padding: 1rem;
  background: var(--leaf-50);
  border: 1px solid var(--leaf-200);
  border-radius: 8px;
  text-align: center;
}

.status-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
  color: var(--leaf-700);
  font-weight: 600;
}

.status-indicator i {
  color: var(--leaf-500);
}

.pulse {
  animation: pulse 2s infinite;
}

.status-text {
  font-size: 0.875rem;
  color: var(--leaf-600);
}

.room-members {
  background: rgba(255, 255, 255, 0.5);
  border-radius: 12px;
  padding: 1.5rem;
  border: 1px solid var(--gray-200);
}

.room-members h3 {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1rem;
  font-weight: 600;
  color: var(--gray-800);
  margin-bottom: 1rem;
}

.room-members h3 i {
  color: var(--leaf-500);
}

.members-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  max-height: 200px;
  overflow-y: auto;
}

.empty-members {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 2rem 1rem;
  color: var(--gray-500);
  font-size: 0.875rem;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 8px;
  border: 1px dashed var(--gray-300);
}

.empty-members i {
  color: var(--gray-400);
}

.member-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 8px;
  border: 1px solid var(--gray-200);
  transition: all var(--duration-normal) ease;
}

.member-item:hover {
  background: rgba(255, 255, 255, 0.95);
  border-color: var(--leaf-300);
  transform: translateX(2px);
}

.member-avatar {
  width: 36px;
  height: 36px;
  background: var(--gradient-secondary);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 0.875rem;
  flex-shrink: 0;
}

.member-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.member-name {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--gray-800);
}

.member-status {
  font-size: 0.75rem;
}

.status-sharing {
  color: var(--leaf-600);
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.status-watching {
  color: var(--gray-500);
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.member-connection {
  flex-shrink: 0;
}

.member-connection i {
  font-size: 0.75rem;
}

.member-connection i.connected {
  color: var(--leaf-500);
}

.member-connection i.disconnected {
  color: var(--gray-400);
}

.room-stats {
  background: rgba(255, 255, 255, 0.5);
  border-radius: 12px;
  padding: 1.5rem;
  border: 1px solid var(--gray-200);
}

.room-stats h3 {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1rem;
  font-weight: 600;
  color: var(--gray-800);
  margin-bottom: 1rem;
}

.room-stats h3 i {
  color: var(--lemon-500);
}

.stats-grid {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.stat-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 8px;
  border: 1px solid var(--gray-100);
}

.stat-content {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.stat-label {
  font-size: 0.75rem;
  color: var(--gray-500);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  font-weight: 500;
}

.stat-value {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--gray-800);
}

.stat-value.sharing {
  color: var(--leaf-600);
}

.stat-value.idle {
  color: var(--gray-500);
}

/* 房间成员样式 */
.room-members {
  background: rgba(255, 255, 255, 0.5);
  border-radius: 12px;
  padding: 1.5rem;
  border: 1px solid var(--gray-200);
}

.room-members h3 {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1rem;
  font-weight: 600;
  color: var(--gray-800);
  margin-bottom: 1rem;
}

.room-members h3 i {
  color: var(--leaf-500);
}

.members-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.empty-members {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 2rem 1rem;
  color: var(--gray-500);
  font-size: 0.875rem;
  text-align: center;
}

.empty-members i {
  font-size: 1.5rem;
  color: var(--gray-400);
}

.member-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 8px;
  border: 1px solid var(--gray-100);
  transition: all var(--duration-normal) ease;
}

.member-item:hover {
  background: rgba(255, 255, 255, 0.9);
  transform: translateY(-1px);
  box-shadow: var(--shadow-sm);
}

.member-avatar {
  width: 36px;
  height: 36px;
  background: var(--gradient-secondary);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 0.875rem;
  flex-shrink: 0;
}

.member-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.member-name {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--gray-800);
}

.member-status {
  font-size: 0.75rem;
}

.status-sharing {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  color: var(--leaf-600);
  font-weight: 500;
}

.status-watching {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  color: var(--gray-500);
}

.member-connection {
  flex-shrink: 0;
}

.member-connection i {
  font-size: 0.5rem;
}

.member-connection i.connected {
  color: var(--leaf-500);
}

.member-connection i.disconnected {
  color: var(--gray-400);
}

/* 自定义滚动条样式 */
.control-panel::-webkit-scrollbar {
  width: 6px;
}

.control-panel::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 3px;
}

.control-panel::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
  transition: background 0.2s ease;
}

.control-panel::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.3);
}

/* 响应式设计 */
@media (max-width: 1024px) {
  .control-panel {
    position: static;
    height: auto;
    overflow-y: visible;
  }
}


@media (max-width: 768px) {
  .control-panel {
    padding: 1.5rem;
  }
  
  .panel-header h2 {
    font-size: 1.125rem;
  }
  
  .stats-grid {
    gap: 0.5rem;
  }
  
  .stat-item {
    padding: 0.5rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ControlPanel.css"],"names":[],"mappings":"AAAA,WAAW;;AAEX;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;;AAGA;EACE,kBAAkB;EAClB,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,iCAAiC;EACjC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,oCAAoC;EACpC,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,oCAAoC;EACpC,kBAAkB;EAClB,iCAAiC;EACjC,2CAA2C;AAC7C;;AAEA;EACE,qCAAqC;EACrC,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,oCAAoC;EACpC,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,WAAW;AACX;EACE,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,oCAAoC;EACpC,kBAAkB;EAClB,iCAAiC;EACjC,2CAA2C;AAC7C;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,aAAa;AACb;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA,UAAU;AACV;EACE;IACE,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;EACrB;AACF;;;AAGA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* 控制面板样式 */\n\n.control-panel {\n  padding: 2rem;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n  position: relative;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n\n.panel-header {\n  text-align: center;\n  border-bottom: 1px solid var(--gray-200);\n  padding-bottom: 1.5rem;\n}\n\n.panel-header h2 {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.75rem;\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: var(--gray-800);\n  margin-bottom: 0.5rem;\n}\n\n.panel-header h2 i {\n  color: var(--mango-500);\n}\n\n.panel-header p {\n  color: var(--gray-600);\n  font-size: 0.875rem;\n}\n\n.panel-content {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.share-controls {\n  background: rgba(255, 255, 255, 0.5);\n  border-radius: 12px;\n  padding: 1.5rem;\n  border: 1px solid var(--gray-200);\n}\n\n.share-controls h3 {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--gray-800);\n  margin-bottom: 1rem;\n}\n\n.share-controls h3 i {\n  color: var(--leaf-500);\n}\n\n.control-buttons {\n  margin-bottom: 1rem;\n}\n\n.sharing-status {\n  padding: 1rem;\n  background: var(--leaf-50);\n  border: 1px solid var(--leaf-200);\n  border-radius: 8px;\n  text-align: center;\n}\n\n.status-indicator {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  margin-bottom: 0.5rem;\n  color: var(--leaf-700);\n  font-weight: 600;\n}\n\n.status-indicator i {\n  color: var(--leaf-500);\n}\n\n.pulse {\n  animation: pulse 2s infinite;\n}\n\n.status-text {\n  font-size: 0.875rem;\n  color: var(--leaf-600);\n}\n\n.room-members {\n  background: rgba(255, 255, 255, 0.5);\n  border-radius: 12px;\n  padding: 1.5rem;\n  border: 1px solid var(--gray-200);\n}\n\n.room-members h3 {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--gray-800);\n  margin-bottom: 1rem;\n}\n\n.room-members h3 i {\n  color: var(--leaf-500);\n}\n\n.members-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.empty-members {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  padding: 2rem 1rem;\n  color: var(--gray-500);\n  font-size: 0.875rem;\n  background: rgba(255, 255, 255, 0.7);\n  border-radius: 8px;\n  border: 1px dashed var(--gray-300);\n}\n\n.empty-members i {\n  color: var(--gray-400);\n}\n\n.member-item {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.75rem;\n  background: rgba(255, 255, 255, 0.8);\n  border-radius: 8px;\n  border: 1px solid var(--gray-200);\n  transition: all var(--duration-normal) ease;\n}\n\n.member-item:hover {\n  background: rgba(255, 255, 255, 0.95);\n  border-color: var(--leaf-300);\n  transform: translateX(2px);\n}\n\n.member-avatar {\n  width: 36px;\n  height: 36px;\n  background: var(--gradient-secondary);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-size: 0.875rem;\n  flex-shrink: 0;\n}\n\n.member-info {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.member-name {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--gray-800);\n}\n\n.member-status {\n  font-size: 0.75rem;\n}\n\n.status-sharing {\n  color: var(--leaf-600);\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n}\n\n.status-watching {\n  color: var(--gray-500);\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n}\n\n.member-connection {\n  flex-shrink: 0;\n}\n\n.member-connection i {\n  font-size: 0.75rem;\n}\n\n.member-connection i.connected {\n  color: var(--leaf-500);\n}\n\n.member-connection i.disconnected {\n  color: var(--gray-400);\n}\n\n.room-stats {\n  background: rgba(255, 255, 255, 0.5);\n  border-radius: 12px;\n  padding: 1.5rem;\n  border: 1px solid var(--gray-200);\n}\n\n.room-stats h3 {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--gray-800);\n  margin-bottom: 1rem;\n}\n\n.room-stats h3 i {\n  color: var(--lemon-500);\n}\n\n.stats-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.stat-item {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.75rem;\n  background: rgba(255, 255, 255, 0.7);\n  border-radius: 8px;\n  border: 1px solid var(--gray-100);\n}\n\n.stat-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.stat-label {\n  font-size: 0.75rem;\n  color: var(--gray-500);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  font-weight: 500;\n}\n\n.stat-value {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--gray-800);\n}\n\n.stat-value.sharing {\n  color: var(--leaf-600);\n}\n\n.stat-value.idle {\n  color: var(--gray-500);\n}\n\n/* 房间成员样式 */\n.room-members {\n  background: rgba(255, 255, 255, 0.5);\n  border-radius: 12px;\n  padding: 1.5rem;\n  border: 1px solid var(--gray-200);\n}\n\n.room-members h3 {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--gray-800);\n  margin-bottom: 1rem;\n}\n\n.room-members h3 i {\n  color: var(--leaf-500);\n}\n\n.members-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.empty-members {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  padding: 2rem 1rem;\n  color: var(--gray-500);\n  font-size: 0.875rem;\n  text-align: center;\n}\n\n.empty-members i {\n  font-size: 1.5rem;\n  color: var(--gray-400);\n}\n\n.member-item {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.75rem;\n  background: rgba(255, 255, 255, 0.7);\n  border-radius: 8px;\n  border: 1px solid var(--gray-100);\n  transition: all var(--duration-normal) ease;\n}\n\n.member-item:hover {\n  background: rgba(255, 255, 255, 0.9);\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-sm);\n}\n\n.member-avatar {\n  width: 36px;\n  height: 36px;\n  background: var(--gradient-secondary);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-size: 0.875rem;\n  flex-shrink: 0;\n}\n\n.member-info {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.member-name {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--gray-800);\n}\n\n.member-status {\n  font-size: 0.75rem;\n}\n\n.status-sharing {\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n  color: var(--leaf-600);\n  font-weight: 500;\n}\n\n.status-watching {\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n  color: var(--gray-500);\n}\n\n.member-connection {\n  flex-shrink: 0;\n}\n\n.member-connection i {\n  font-size: 0.5rem;\n}\n\n.member-connection i.connected {\n  color: var(--leaf-500);\n}\n\n.member-connection i.disconnected {\n  color: var(--gray-400);\n}\n\n/* 自定义滚动条样式 */\n.control-panel::-webkit-scrollbar {\n  width: 6px;\n}\n\n.control-panel::-webkit-scrollbar-track {\n  background: rgba(255, 255, 255, 0.3);\n  border-radius: 3px;\n}\n\n.control-panel::-webkit-scrollbar-thumb {\n  background: rgba(0, 0, 0, 0.2);\n  border-radius: 3px;\n  transition: background 0.2s ease;\n}\n\n.control-panel::-webkit-scrollbar-thumb:hover {\n  background: rgba(0, 0, 0, 0.3);\n}\n\n/* 响应式设计 */\n@media (max-width: 1024px) {\n  .control-panel {\n    position: static;\n    height: auto;\n    overflow-y: visible;\n  }\n}\n\n\n@media (max-width: 768px) {\n  .control-panel {\n    padding: 1.5rem;\n  }\n  \n  .panel-header h2 {\n    font-size: 1.125rem;\n  }\n  \n  .stats-grid {\n    gap: 0.5rem;\n  }\n  \n  .stat-item {\n    padding: 0.5rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
